<template>
    <div class="cl-inner">
        <div class="title">基础信息</div>
        <a-form :form="form">
            <div class="form-item">
                <div class="item-title">logo</div>
                <div>
                    <a-form-item :required="true">
                        <!-- <div class="title">正面免冠照片（2寸）</div> -->
                        <!-- <c-upload accept="image/*" @uploadSuccess="uploadSuccess_logo" class="fullFaced" ref="logoImg"
                            :isSingle="false" :maxlength="1" :maxFileSize="2097152" :imageMatchHeight="240"
                            :imageMatchWidth="240" :sourceFileList="sourceFileList_logo"></c-upload> -->
                        <!-- 限制照片为两寸  :twoInches="true"-->
                        <!-- <div class="remark">
                  符合宽高413×626像素200KB以内，支持jpeg,jpg,png
                </div> -->
                        <div class="logo-item">
                            <a-upload :file-list="fileListLogo" :show-upload-list="false"
                                action="https://www.mocky.io/v2/5cc8019d300000980a055e76" accept=".png, .jpg"
                                :remove="removeUploadSuccess_logo" name="avatar" list-type="picture-card"
                                class="avatar-uploader" maxCount="1" :before-upload="beforeUploadLogo"
                                @change="uploadSuccess_logo">
                                <img v-if="imageLogoUrl" style="width:102.4px;height:102.4px;" :src="imageLogoUrl"
                                    alt="avatar" />
                                <div v-else>
                                    <!-- <loading-outlined v-if="loading"></loading-outlined> -->
                                    <!-- <plus-outlined v-else></plus-outlined> -->
                                    <!-- <picture-outlined /> -->
                                    <!-- <div class="ant-upload-text"><a-icon type="picture" size="large" /></div>
                                     -->
                                     <div class="ant-upload-text"><img src="/images/uploadBg.png" alt="" width="40px"></div>
                                </div>
                            </a-upload>
                            <img v-if="imageLogoUrl" class="load-preview" style="width: 20px;height: 20px;z-index: 1000;"
                                @click="preview(imageLogoUrl)" src="/images/preview.png" />
                            <img v-if="imageLogoUrl" class="load" style="width: 20px;height: 20px;z-index: 1000;" @click="removeUploadSuccess_logo"
                                src="/images/delete.png" />
                        </div>
                    </a-form-item>
                    <div class="explan explan-top">上传240*240px 2MB以内 .JPG .PNG格式图片</div>
                </div>
            </div>
            <div class="form-item bg-parent">
                <div class="item-title">背景图</div>
                <div>
                    <!-- <a-col :span="8"> -->
                    <a-form-item :required="true">
                        <!-- <div class="title">正面免冠照片（2寸）</div> -->
                        <!-- <c-upload accept="image/*" @uploadSuccess="uploadSuccess_background" class="fullFaced"
                            ref="teacherBareheadedImgUrl" :isSingle="false" :maxlength="1" :maxFileSize="5242880"
                            :imageMatchHeight="480" :imageMatchWidth="1920" 
                            :sourceFileList="sourceFileList_background"></c-upload> -->
                        <!-- 限制照片为两寸  :twoInches="true"-->
                        <div class="background-item">
                        <a-upload :file-list="fileListBackground" accept=".png, .jpg" :remove="removeUploadSuccess_background" name="avatar"
                            list-type="picture-card" class="avatar-uploader-bc" :show-upload-list="false"
                            action="https://www.mocky.io/v2/5cc8019d300000980a055e76" :before-upload="beforeUploadBackground"
                            @change="uploadSuccess_background">
                            <img v-if="imageBackgroundUrl" style="width:300px;height:102.4px;" :src="imageBackgroundUrl"
                                alt="avatar" />
                            <div v-else>
                                <!-- <loading-outlined v-if="loading"></loading-outlined>
                            <plus-outlined v-else></plus-outlined> -->
                                <div class="ant-upload-text"><img src="/images/uploadBg.png" alt="" width="40px"></div>
                            </div>
                        </a-upload>
                        <img v-if="imageBackgroundUrl" class="load-preview" style="width: 20px;height: 20px;z-index: 1000;"
                                @click="preview(imageBackgroundUrl)" src="/images/preview.png" />
                            <img v-if="imageBackgroundUrl" class="load" style="width: 20px;height: 20px;z-index: 1000;" @click="removeUploadSuccess_background"
                                src="/images/delete.png" />
                    </div>
                        <span class="explan">上传1920*480px 5MB以内 .JPG .PNG格式图片</span>
                    </a-form-item>
                    <!-- </a-col> -->
                    <!-- <a-upload v-model:file-list="fileList" name="avatar" list-type="picture-card" class="avatar-uploader-bc"
                        :show-upload-list="false" action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                        :before-upload="beforeUpload" @change="handleChange">
                        <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
                        <div v-else>
                            <loading-outlined v-if="loading"></loading-outlined>
                            <plus-outlined v-else></plus-outlined>
                            <div class="ant-upload-text"><img src="/images/uploadBg.png"  alt="" width="40px"></div>
                        </div>
                    </a-upload> -->
                </div>
            </div>
            <div class="form-item form-item-none">
                <div class="item-title">学校地址</div>
                <div>
                    <a-input class="domain-input" v-model="domainName" type="text"
                        placeholder="智慧校园/组织管理" />&nbsp;&nbsp;.khsdb.com
                </div>
            </div>
            <div class="form-item">
                <div class="item-title">家长端设置</div>
                <div>


                    <a-form-item :required="true">
                        <!-- <div class="title">正面免冠照片（2寸）</div> -->
                        <!-- <c-upload accept="image/*" @uploadSuccess="uploadSuccess_qrcode" class="fullFaced"
                            ref="teacherBareheadedImgUrl" :isSingle="false" :maxlength="1" :maxFileSize="3145728"
                            :imageMatchHeight="500" :imageMatchWidth="500" 
                            :sourceFileList="sourceFileList_qrcode"></c-upload> -->
                        <!-- 限制照片为两寸  :twoInches="true"-->
                        <!-- <div class="remark">
                  符合宽高413×626像素200KB以内，支持jpeg,jpg,png
                </div> -->
                        <div class="qrcode-item">
                        <a-upload style="width: 300px;" :file-list="fileListQrcode" accept=".png, .jpg" :remove="removeUploadSuccess_qrcode"
                            name="avatar" list-type="picture-card" class="avatar-uploader" :show-upload-list="false"
                            action="https://www.mocky.io/v2/5cc8019d300000980a055e76" :before-upload="beforeUploadQrcode"
                            @change="uploadSuccess_qrcode">
                            <img v-if="imageQrcodeUrl" style="width:102.4px;height:102.4px;" :src="imageQrcodeUrl"
                                alt="avatar" />
                            <div v-else>
                                <!-- <loading-outlined v-if="loading"></loading-outlined> -->
                                <!-- <plus-outlined v-else></plus-outlined> -->
                                <div class="ant-upload-text"><img src="/images/qrCode.png" alt="" width="30px"></div>
                            </div>
                        </a-upload>
                        <img class="load-preview" v-if="imageQrcodeUrl" style="width: 20px;height: 20px;z-index: 1000;"
                                @click="preview(imageQrcodeUrl)" src="/images/preview.png" />
                            <img class="load" v-if="imageQrcodeUrl" style="width: 20px;height: 20px;z-index: 1000;" @click="removeUploadSuccess_qrcode"
                                src="/images/delete.png" />
                    </div>
                    </a-form-item>
                    <div class="explan explan-top">上传家长端小程序二维码500*500px 3MB以内 .JPG .PNG格式图片</div>
                </div>
            </div>
            <a-button type="primary" class="confirm-button" @click="confirm()">确认修改</a-button>
        </a-form>
    </div>
</template>
<script>
import bureau from '../../api/bureau'
import globalConfig from '../../config/globle.config';
import { Icon } from 'ant-design-vue';
import setting from '../../api/setting'
import CUpload from '../../components/CUpload';
export default {
    components: {
        CUpload,
    },
    name: 'basicSettings',
    data() {
        return {
            form: this.$form.createForm(this),
            tabIndex: '4',
            domainInfo: {},
            fileListLogo: [{
                uid: '-1',
                name: 'xxx.png',
                status: 'done',
                url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
                thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
            }],
            fileListBackground: [],
            fileListQrcode: [],
            sourceFileList_logo: [],
            sourceFileList_background: [],
            sourceFileList_qrcode: [],
            domainName: '',
            substance_logo: [],
            substance_background: [],
            substance_qrcode: [],
            picture: 'picture',
            imageLogoUrl: '',
            imageBackgroundUrl: '',
            imageQrcodeUrl: '',
            backgroundImgId: '',
            parentSideImgId: '',
            backgroundImgFileId:'',
            logoImgFileId:'',
        }
    },
    methods: {
        preview(str) {
            window.open(str, '_blank')
        },
        beforeUploadLogo(file) {
            return new Promise((resolve, reject) => {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' //这里获取上传文件的类型
                if (!isJpgOrPng) {
                    this.$message.warning('请上传jpg图片')
                    return reject(false);  //如有问题那咱们通过reject 函数传一个false阻止他的上传
                }
                console.log(file, 'filefilefile')
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('图片大小不能超过2M');
                    return reject(false);
                }

                if (isJpgOrPng) {
                    let reader = new FileReader(); //这个是通过原生的方式来获取图片的宽高
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        const image = new Image();
                        image.src = reader.result;
                        image.onload = () => {
                            let w = image.width;
                            let h = image.height;
                            if (w != 240 && h != 240) {
                                this.$message.warning('请上传240*240px的图片')
                                return reject(false);  // //如有问题那咱们通过reject 函数传一个false阻止他的上传
                            } else {
                                return resolve(true) //如没有问题了那咱们就通过resolve函数添加一个true 让文件上传
                            }
                        }
                    }
                }
            });
        },
        beforeUploadBackground(file) {
            return new Promise((resolve, reject) => {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' //这里获取上传文件的类型
                if (!isJpgOrPng) {
                    this.$message.warning('请上传jpg图片')
                    return reject(false);  //如有问题那咱们通过reject 函数传一个false阻止他的上传
                }
                console.log(file, 'filefilefile')
                const isLt2M = file.size / 1024 / 1024 < 5;
                if (!isLt2M) {
                    this.$message.error('图片大小不能超过5M');
                    return reject(false);
                }

                if (isJpgOrPng) {
                    let reader = new FileReader(); //这个是通过原生的方式来获取图片的宽高
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        const image = new Image();
                        image.src = reader.result;
                        image.onload = () => {
                            let w = image.width;
                            let h = image.height;
                            if (w != 1920 && h != 480) {
                                this.$message.warning('请上传1920*480px的图片')
                                return reject(false);  // //如有问题那咱们通过reject 函数传一个false阻止他的上传
                            } else {
                                return resolve(true) //如没有问题了那咱们就通过resolve函数添加一个true 让文件上传
                            }
                        }
                    }
                }
            });
        },
        beforeUploadQrcode(file) {
            return new Promise((resolve, reject) => {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' //这里获取上传文件的类型
                if (!isJpgOrPng) {
                    this.$message.warning('请上传jpg图片')
                    return reject(false);  //如有问题那咱们通过reject 函数传一个false阻止他的上传
                }
                console.log(file.size / 1024 / 1024 < 3, 'filefilefile')
                const isLt2M = file.size / 1024 / 1024 < 3;
                if (!isLt2M) {
                    this.$message.error('图片大小不能超过3M');
                    return reject(false);
                }

                if (isJpgOrPng) {
                    let reader = new FileReader(); //这个是通过原生的方式来获取图片的宽高
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        const image = new Image();
                        image.src = reader.result;
                        image.onload = () => {
                            let w = image.width;
                            let h = image.height;
                            if (w != 500 && h != 500) {
                                this.$message.warning('请上传500*500px的图片')
                                return reject(false);  // //如有问题那咱们通过reject 函数传一个false阻止他的上传
                            } else {
                                return resolve(true) //如没有问题了那咱们就通过resolve函数添加一个true 让文件上传
                            }
                        }
                    }
                }
            });
        },
        handleChange(res) {
            // this.fileListLogo = res
            console.log(this.fileListLogo, res, 'handleChangehandleChange')
            setting.commonUpload({ fileName: res.file.originFileObj }).then((res) => {
                console.log(res, 'getTermAndSchoolListres')
            })
        },
        // 获取学校的接口
        getSchoolBaseInfos() {
            setting.getSchoolBaseInfo().then((res) => {
                console.log(res, 'getSchoolBaseInfos')
                let formData = {}
                this.domainName = res.data.domainName && res.data.domainName.replace(/(.khsdb.com)$/, '')
                this.imageLogoUrl = res.data.logoImg
                this.imageBackgroundUrl = res.data.backgroundImgUrl
                this.imageQrcodeUrl = res.data.parentSideImgUrl
                this.backgroundImgId = res.data.backgroundImgId
                this.parentSideImgId = res.data.parentSideImgId
                this.backgroundImgFileId = res.data.backgroundImgFileId
                this.parentSideImgFileId = res.data.parentSideImgFileId
                this.logoImgFileId = res.data.logoImgFileId
            })
        },
        // 确认修改 保存项目的接口
        confirm() {
            console.log(this.substance_logo,this.substance_background,'123456789')
            let data = {}
            data.domainName = this.domainName && this.domainName + '.khsdb.com'
            // 传入logoUrl
            data.logoImgUrl = this.imageLogoUrl ? this.imageLogoUrl : ''
            data.backgroundImgUrl = this.imageBackgroundUrl?this.imageBackgroundUrl:''
            data.parentSideImgUrl = this.imageQrcodeUrl ? this.imageQrcodeUrl : ''
            // upload接口返回的id
            data.logoImgFileId = this.substance_logo && this.substance_logo.id ? this.substance_logo.id : this.logoImgFileId?this.logoImgFileId:''
            data.backgroundImgFileId = this.substance_background && this.substance_background.id ? this.substance_background.id : this.backgroundImgFileId ? this.backgroundImgFileId : ''
            data.parentSideImgFileId = this.substance_qrcode && this.substance_qrcode.id ? this.substance_qrcode.id : this.parentSideImgFileId ? this.parentSideImgFileId : ''
            // 接口查询的id
            // data.logoImgId = this.substance_logo.id ? this.substance_logo.id : null
            data.backgroundImgId = this.backgroundImgId ? this.backgroundImgId : ''
            data.parentSideImgId = this.parentSideImgId ? this.parentSideImgId : ''
            // 图片名称
            data.backgroundImgName = this.substance_background && this.substance_background.fileRealname ? this.substance_background.fileRealname : ''
            data.parentSideImgName = this.substance_qrcode && this.substance_qrcode.fileRealname ? this.substance_qrcode.fileRealname : ''
            setting.saveOneSchoolOneProject(data).then((res) => {
                console.log(res.msg, 'saveOneSchoolOneProject')
                if(res.msg == 'success'){
                    this.$message.success("修改成功")
                } else{
                    this.$message.error("修改失败")
                }
            })
        },

        // 上传logo
        uploadSuccess_logo(url) {

            this.fileListLogo = []
            console.log(url, this.imageLogoUrl, 'uploadSuccess_logoURL')
            // if (url.length > 0) {
            // this.fileListLogo = url
            // this.substance_logo = url
            console.log(this.sourceFileList_logo, url, 'logo图片')
            setting.commonUpload({ fileName: url.file.originFileObj }).then((res) => {
                this.substance_logo = res.data
                console.log(res.data, 'getTermAndSchoolListres')
                this.imageLogoUrl = res.data.fileUrl
                this.fileListLogo.push({
                    uid: res.data.id,
                    name: res.data.fileUrl,
                    status: 'done',
                    url: res.data.fileUrl,
                    thumbUrl: res.data.fileUrl,
                })
            })
            // }
        },
        removeUploadSuccess_logo(e) {
            e.preventDefault();
            console.log('删除进来了吗')
            this.fileListLogo = []
            this.imageLogoUrl = ''
            this.substance_logo = []
        },
        removeUploadSuccess_background() {
            this.fileListBackground = []
            this.imageBackgroundUrl = ''
            this.substance_background = []
        },
        uploadSuccess_background(url) {
            // if (url.length > 0) {
            // this.sourceFileList_background = url[0].url
            // this.substance_background = url
            console.log(this.sourceFileList_background, url, '背景图片')
            setting.commonUpload({ fileName: url.file.originFileObj }).then((res) => {
                this.substance_background = res.data
                console.log(res, 'getTermAndSchoolListres')
                this.imageBackgroundUrl = res.data.fileUrl
                this.fileListBackground.push({
                    uid: res.data.id,
                    name: res.data.fileUrl,
                    status: 'done',
                    url: res.data.fileUrl,
                    thumbUrl: res.data.fileUrl,
                })
            })
            // }
        },
        removeUploadSuccess_qrcode() {
            this.fileListQrcode = []
            this.imageQrcodeUrl = ''
            this.substance_qrcode = []
        },
        uploadSuccess_qrcode(url) {
            // if (url.length > 0) {
            // this.sourceFileList_qrcode = url[0].url
            // this.substance_qrcode = url
            console.log(this.sourceFileList_qrcode, url, '二维码图片')
            setting.commonUpload({ fileName: url.file.originFileObj }).then((res) => {
                this.substance_qrcode = res.data
                console.log(res, 'getTermAndSchoolListres')
                this.imageQrcodeUrl = res.data.fileUrl
                this.fileListQrcode.push({
                    uid: res.data.id,
                    name: res.data.fileUrl,
                    status: 'done',
                    url: res.data.fileUrl,
                    thumbUrl: res.data.fileUrl,
                })
            })
            // }
        },
    },
    created() {
        this.getSchoolBaseInfos()
    }
}
</script>
<style lang="scss" scoped>
.cl-inner {
    background: #fff;
    margin: 20px;
    padding: 40px;
    box-sizing: border-box;
}

.title {
    font-weight: bold;
    font-size: 20px;
}

.form-item {
    margin-top: 30px;
    display: flex;
}

.item-title {
    width: 200px;
}

.confirm-button {
    width: 114px;
    height: 38px;
    margin: 30px 0 0 200px;
}

.explan {
    color: #A6A6A6;
}


.bg-parent ::v-deep .ant-upload-select-picture-card {
    width: 350px !important;
}

.bg-parent ::v-deep .ant-upload-list-item {
    width: 350px;
}

::v-deep .anticon-picture {
    font-size: 20px;
}

.domain-input{
    width:450px;
}
.load {
    position: absolute;
    top: 0;
    left: 10px;
    bottom: 0;
    right: 0;
    margin: auto;
    display: none;
}

.load-preview {
    position: absolute;
    top: 0;
    left: -30px;
    bottom: 0;
    right: 0;
    margin: auto;
    display: none;
}

.logo-item {
    position: relative;
    width: 102px;
    height: 102px;
}

.logo-item:hover {
    z-index: 2000;
}
.qrcode-item{
    position: relative;
    width: 102px;
    height: 102px;
}

.logo-item:hover {
    .load {
        top: 10px;
        left: 55px;
        display: block;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 2px;
    }

    .load-preview {
        display: block;
        top: 10px;
        left: 0px;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 2px;
    }
}

.background-item{
    height: 120px;
}
.background-item:hover {
    background: transparent;
    .load {
        display: block;
        top: -40px;
        left: 110px;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 2px;
    }

    .load-preview {
        display: block;
        top: -40px;
        left: 55px;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 2px;
    }
}


.qrcode-item:hover {
    background: transparent;
    .load {
        top: 20px;
        left: 45px;
        display: block;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 2px;
    }

    .load-preview {
        top: 20px;
        left: -5px;
        display: block;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 2px;
    }
}

.explan-top{
    padding-top: 8px;
}

.item-title{
    color: #171A1D;
}

.form-item-none{
    margin: 10px 0 10px 0;
    align-items: center;
}
</style>